// Grab a frame ~1s in (or midway for very short clips) and the duration
export function extractVideoThumbnail(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const v = document.createElement("video");
    const cleanup = () => URL.revokeObjectURL(url);
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error("thumbnail timeout"));
    }, 15000);
    v.preload = "metadata";
    v.muted = true;
    v.playsInline = true;
    v.src = url;
    v.onloadedmetadata = () => {
      const duration = isFinite(v.duration) ? v.duration : 0;
      v.currentTime = Math.min(1, duration / 2 || 0);
      v.onseeked = () => {
        const c = document.createElement("canvas");
        c.width = v.videoWidth || 640;
        c.height = v.videoHeight || 360;
        c.getContext("2d").drawImage(v, 0, 0, c.width, c.height);
        c.toBlob(
          (blob) => {
            clearTimeout(timer);
            cleanup();
            resolve({ blob, duration: Math.round(duration) });
          },
          "image/jpeg",
          0.7
        );
      };
    };
    v.onerror = () => {
      clearTimeout(timer);
      cleanup();
      reject(new Error("could not read video"));
    };
  });
}
